import { useCallback, useState } from "react";
import { SendPrescriptionForm } from "pages/patient/PatientMedicationPage/components/Prescriptions/Table/SendPrescriptionForm.jsx";

import { AddPrescriptionForm } from "components/AddPrescriptionForm/AddPrescriptionForm.jsx";
import { downloadPrescription, printPrescription } from "components/AddPrescriptionForm/utils";
import { Button } from "components/ui/Button";
import { Dialog } from "components/ui/Dialog";
import { useActiveConsultationPrescription } from "features/medications/hooks/useActiveConsultationPrescription";
import { useCurrentPatientId } from "features/patients/hooks/useCurrentPatientId";

import s from "./tabs.module.css";

export const PrescriptionTab = ({ consultationId, isReadOnly = false, resetOnSuccess = false }) => {
  const patientId = useCurrentPatientId();
  const tenantVal = localStorage.getItem("kinesin-tenant");
  const [isSendModalOpen, setIsSendModalOpen] = useState(false);
  const [selectedPrescription, setSelectedPrescription] = useState(null);
  const [formKey, setFormKey] = useState(0);

  const isStandalone = consultationId === null || consultationId === undefined;

  const { initialData, isLoading, refetch: refetchPrescription } =
    useActiveConsultationPrescription(consultationId);

  const handlePrescriptionSaved = useCallback(async () => {
    await refetchPrescription();
    setFormKey((k) => k + 1);
  }, [refetchPrescription]);

  if (!isStandalone && isLoading) return null;

  return (
    <>
      {!isReadOnly && (
        <>
          <Dialog
            title="Send to pharmacy"
            onClose={() => setIsSendModalOpen(false)}
            width={560}
            open={isSendModalOpen && !!selectedPrescription}
          >
            <SendPrescriptionForm
              onSuccess={() => {
                setIsSendModalOpen(false);
                if (isStandalone || resetOnSuccess) setFormKey((k) => k + 1);
              }}
              onSkip={() => {
                setIsSendModalOpen(false);
                if (isStandalone || resetOnSuccess) setFormKey((k) => k + 1);
              }}
              prescriptionId={selectedPrescription?.id}
              patientId={patientId}
            />
          </Dialog>
        </>
      )}
      <div
        className={
          isReadOnly && initialData?.medicines?.length
            ? s.readOnlyContent
            : undefined
        }
      >
        <AddPrescriptionForm
          key={`${formKey}-${initialData?.id ?? "new"}`}
          autoSave={!isReadOnly && !isStandalone}
          isReadOnly={isReadOnly}
          consultationId={consultationId}
          onSaved={!isReadOnly && !isStandalone ? handlePrescriptionSaved : undefined}
          onSuccess={
            !isReadOnly
              ? (res) => {
                  setSelectedPrescription(res);
                  setIsSendModalOpen(true);
                }
              : undefined
          }
          initialData={initialData ?? {}}
        />
      </div>

      {isReadOnly && initialData?.filePath && initialData?.id && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "12px",
            marginTop: "12px",
          }}
        >
          <Button
            variant="outline"
            size="large"
            type="button"
            onClick={() =>
              printPrescription(initialData.id, tenantVal, patientId)
            }
          >
            Print prescription
          </Button>
          <Button
            variant="primary"
            size="large"
            type="button"
            onClick={() =>
              downloadPrescription(initialData.id, tenantVal, patientId)
            }
          >
            Download prescription
          </Button>
        </div>
      )}
    </>
  );
};
